export default __webpack_public_path__ + "images/cancerfondsrapporten/pharmaceutical-step-3.png";